import { createI18n } from 'vue-i18n'

// Import locale messages
import en from '@/locales/en.json'
import de from '@/locales/de.json'

// Define message type for better TypeScript support
type MessageSchema = typeof en

const currentLanguage = localStorage.getItem('appLanguage')
// Create Vue I18n instance
const i18n = createI18n<[MessageSchema], 'en' | 'de'>({
  legacy: false, // Required for Vue 3 Composition API
  locale: currentLanguage ? currentLanguage : 'de', // Default language
  fallbackLocale: 'de', // Fallback language
  messages: { en, de },
})

export default i18n
